import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

const isProd = process.env.REACT_APP_ENVIRONMENT === "production";

// Ouvrir dans un nouvel onglet en prod uniquement
// En recette et localhost: navigation dans le même onglet (session isolée par onglet)
const shouldOpenInNewTab = isProd;

/**
 * Hook pour gérer la navigation selon l'environnement.
 * En production et localhost, les liens s'ouvrent dans un nouvel onglet.
 * En recette, les liens s'ouvrent dans le même onglet.
 */
export const useEnvironmentNavigation = () => {
	const navigate = useNavigate();

	/**
	 * Navigue vers une URL.
	 * En production/localhost: ouvre dans un nouvel onglet.
	 * En recette: navigation classique dans le même onglet.
	 */
	const navigateByEnvironment = useCallback(
		(path: string) => {
			if (shouldOpenInNewTab) {
				window.open(path, "_blank", "noopener,noreferrer");
			} else {
				navigate(path);
			}
		},
		[navigate]
	);

	return { navigateByEnvironment, shouldOpenInNewTab };
};
